<div class="inner-modal-content">
    <h3 class="title is-level-1 has-text-centered">Créer une alerte pour un article</h3>
    <p class="text has-text-tertiary has-text-centered">
        <span class="">
            <strong>
                Cet article n'est pas disponible, renseignez votre adresse e-mail pour être informé de sa future
                disponibilité
            </strong>
        </span>
    </p>
    <div class="is-divider is-invisible"></div>
    <div class="columns is-marginless has-text-centered">
        <div class="column is-7 is-offset-1">
            <div class="field">
                <form
                    class="wrapper-form"
                    name="alert"
                    autocomplete="off"
                    (submit)="alertMail()"
                    [formGroup]="alertForm"
                    novalidate
                >
                    <div class="control has-dynamic-placeholder">
                        <input
                            class="input"
                            [ngClass]="{ 'is-danger': isMailInvalid() }"
                            type="text"
                            placeholder="Votre adresse e-mail*"
                            formControlName="email"
                        />
                        <label class="input-dynamic-placeholder">Votre adresse e-mail</label>
                        @if (!isMailLength()) {
                            <p class="help is-info">Veuillez saisir votre adresse e-mail</p>
                        }
                        @if (isMailInvalid()) {
                            <p class="help has-text-danger">L'adresse e-mail est invalide</p>
                        }
                    </div>
                </form>
            </div>
        </div>
        <div class="column is-3">
            <trg-button [loading]="addingMail" (click)="alertMail()" primary>Envoyer</trg-button>
        </div>
    </div>
    <div class="is-divider is-invisible"></div>
    @if (sentRequest && isMailAdded) {
        <div class="column is-full returnMail has-text-centered has-text-weight-semibold">
            <span class="icon is-small is-success is-left">
                <i class="tri-check-circle"></i>
            </span>
            <span>Votre e-mail a bien été ajouté</span>
        </div>
    }
    @if (sentRequest && !isMailAdded) {
        <div class="column is-full returnMail has-text-centered has-text-weight-semibold">
            <span class="icon is-small is-warning is-left">
                <i class="tri-exclamation-circle"></i>
            </span>
            <span>Cet e-mail n'a pas pu être ajouté, veuillez saisir un autre e-mail ou réessayer ultérieurement</span>
        </div>
    }
</div>
